<template>
  <div class="text-center">
    <v-progress-circular color="secondary" indeterminate v-bind="$attrs" v-on="$listeners"/>
  </div>
</template>

<script>
export default {};
</script>
